"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WrappedFetchTransport = exports.setApiHost = void 0;
var transports_1 = require("@sentry/browser/dist/transports");
var sentryMetricLogger_1 = __importDefault(require("./sentryMetricLogger"));
var zdLoggingApihost = 'https://api2.zocdoc.com';
exports.setApiHost = function (apiHost) {
    zdLoggingApihost = apiHost;
};
var WrappedFetchTransport = /** @class */ (function () {
    function WrappedFetchTransport(options) {
        this.options = options;
        this.transport = new transports_1.FetchTransport(options);
    }
    WrappedFetchTransport.prototype.sendEvent = function (event) {
        var metricLogger = new sentryMetricLogger_1.default((event.tags['application_name'] || 'unknown'), zdLoggingApihost);
        var promise = this.transport.sendEvent(event);
        promise.then(function () {
            metricLogger.increment('sentry.event_sent_to_sentry', 1, [
                'status:ok',
            ]);
        }, function (response) {
            var errType = '';
            if (response.status) {
                switch (response.status) {
                    case 403:
                        errType = 'rejected';
                        break;
                    case 429:
                        errType = 'throttled';
                        break;
                    default:
                        errType = response.status;
                }
            }
            else {
                errType =
                    getErrorNameAndMessage(response) || // errName is in the chance this is an error with a name field i.e. AbortError
                        response.reason || // the Sentry Response object has a reason field which they don't seem to use yet
                        response.statusText || // fetch has a statusText which we can fall back on
                        'error'; // last case is in a weird network error case we have something
            }
            metricLogger.increment('sentry.event_sent_to_sentry', 1, [
                'status:error',
                "type:" + errType,
            ]);
        });
        return promise;
    };
    WrappedFetchTransport.prototype.close = function (timeout) {
        return this.transport.close(timeout);
    };
    return WrappedFetchTransport;
}());
exports.WrappedFetchTransport = WrappedFetchTransport;
var getErrorNameAndMessage = function (err) {
    var fullErr = null;
    if (err.name) {
        fullErr = err.name;
        if (err.message) {
            fullErr += ": " + err.message;
        }
    }
    return fullErr;
};
//# sourceMappingURL=wrappedFetchTransport.js.map